import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CarouselModule } from '@coreui/angular';
import { PriceMatcherService, Product } from 'src/app/services/pricematcher.service';

@Component({
    selector: 'product-display',
    imports: [CommonModule, CarouselModule, MatCardModule, MatButtonModule, RouterLink],
    templateUrl: './product-display.component.html',
    styleUrl: './product-display.component.css'
})
export class ProductDisplayComponent implements OnInit {
  product: Product;

  constructor(private service: PriceMatcherService, private route: ActivatedRoute,
    private router: Router,) {

  }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(async (params) => {
      let search: string = params['search'];
      let searchType: string = params['search_type'];

      this.product = await this.service.searchProduct(search);
    });

  }

}
